import type { IConfig } from "@rhc-shared-components/control-wrapper";
import type { ICompanyDetails, IOnBoardingStatusResponse, IProductVersion } from "../constants/pfsContants";
import Env from "../utils/env";
import { getUri } from "../utils/fetch";
import { getTaticIdObj } from "../utils/getTaticIdObj";

// GETs the Onboarding Status
export const getOnboardingStatus = (abortSignal?: AbortSignal): Promise<IOnBoardingStatusResponse> => {
	const uri = Env.hydraAPIURL.clone().setPath(`${Env.hydraAPIPrefix}/companies/current/onboarding/status`);
	const additionalParams: RequestInit = {};

	if (abortSignal) {
		Object.assign(additionalParams, { signal: abortSignal });
	}
	const taticData = getTaticIdObj();
	if (Object.keys(taticData).length > 0) {
		const taticHeaders: HeadersInit = {
			...(taticData?.internalTacticId && {
				"x-rh-omni-itc": taticData.internalTacticId,
			}),
			...(taticData?.externalTacticId && {
				"x-rh-omni-tc": taticData.externalTacticId,
			}),
			...(taticData?.personalizationTacticId && {
				"x-rh-omni-pc": taticData.personalizationTacticId,
			}),
		};
		Object.assign(additionalParams, { headers: taticHeaders });
	}
	return getUri<IOnBoardingStatusResponse>(uri, additionalParams);
};

// GETs the config values
export const getPlsConfig = (abortSignal?: AbortSignal): Promise<IConfig[]> => {
	const params: RequestInit = {};
	if (abortSignal) {
		Object.assign(params, { signal: abortSignal });
	}
	const uri = Env.hydraProxyURLPreprodStage.clone().setPath(`${Env.hydraRestPrefix}/pls_config`);
	return getUri(uri, params);
};

export const fetchCompanyProfileDetails = (abortSignal?: AbortSignal): Promise<ICompanyDetails> => {
	const params: RequestInit = {};
	if (abortSignal) {
		Object.assign(params, { signal: abortSignal });
	}
	const uri = Env.hydraAPIURL.clone().setPath(`${Env.hydraAPIPrefix}/companies/current`);
	return getUri(uri, params);
};

export const getRedHatProductVersionsMetadata = (): Promise<[IProductVersion]> => {
	const uri = Env.hydraProxyURL.clone().setPath(`${Env.hydraCWEAPIPrefix}/v1.0/artifacts/redhat/versions`);
	return getUri(uri, {}, { externalUrl: true });
};
